<template>
  <div class="SalesmanOrderSubmit" >
    <div class="pageContent">
      <XR-head titleText="订单确认" :rightShow="true" ref="headObj"></XR-head>
      <router-link to="/usercenter/address?redirecturl=/usercenter/address">
        <div class="receive-address">    
          <span style="line-height: 40px;font-weight: bold;" v-if="!receiveAddress.Receiver">请选择收货地址</span>
          <div class="mapIcon">
            <img src="/static/icon/address-location.png" />
          </div>
          <div class="address-info" :style="{width:addressInfoWidth+'px'}" v-if="receiveAddress.Receiver">         
            <div class="contract">
              <span class="name">{{receiveAddress.Receiver}}</span>
              <span class="mobile">{{receiveAddress.Phone}}</span>              
            </div>
            <div class="address-content">
              <span class="text">{{receiveAddress.DetailAddress}}</span>
            </div>
          </div>
          <div class="goIcon">
            <i class="fa fa-angle-right"></i>
          </div>
        </div>
      </router-link>
	  
<div style="margin-bottom:56px;">      
      <div class="pro-list">
        <div class="pro-item" v-for="pItem in productInfoList" :key="pItem.SkuId">
          <div class="pro-img">
            <img :src="pItem.DefaultImg?pItem.DefaultImg:IMGServer_URL+'/images/index-item-default.png'" />
          </div>
          <div class="pro-info" :style="{width:cartItemProductInfoWidth+'px'}">
            <p class="pro-name">{{pItem.Name}}</p>
            <p class="pro-attr">
              <template v-for="attrItem in pItem.Attrs">
                {{attrItem.AttrName +":" + attrItem.AttrValue}} 
              </template>
            </p>
            <div class="pro-num">
              <p class="pro-price">              
                <template v-if="pItem.State==0">
                  <i class="fa fa-rmb"></i>{{pItem.SalePrice.toFixed(2)}}
                </template>
                <template v-else>
                  商品已下架
                </template>
              </p>
              <div class="count">x 1</div>
            </div>
          </div>
        </div>
      </div>

      <div class="remark">
        <mu-text-field label="留言" hintText="最长不超过50个字符" v-model="orderInfo.remark" fullWidth multiLine :rows="1" :rowsMax="6" helpText="选填:给商家留言" :errorText="multiLineInputErrorText" @textOverflow="handleMultiLineOverflow" :maxLength="50"/>
      </div>

      <div class="price-info">
        <div class="row">
          <p class="title">商品金额</p>
          <p class="price">
            <i class="fa fa-rmb"></i>
            <span>{{totalPrice.toFixed(2)}}</span>
          </p>
        </div>
      </div>
</div>
      
      </div>
	  
	  <mu-divider />
      <div class="bottom-bar">
        <mu-row >
          <mu-col width="65" tablet="65" desktop="65">
            <p class="cart-total">
              <span>实付款：<i class="fa fa-rmb"></i></span>
              <span class="money">{{totalPayPrice.toFixed(2)}}</span>
            </p>
          </mu-col>
          <mu-col width="35" tablet="35" desktop="35">
            <mu-flat-button label="提交订单" class="gobuy" backgroundColor="red" color="white" fullWidth @click="orderSubmit" />
          </mu-col>
        </mu-row>
	  
	  
    </div>
    <XR-toast @onClose="submitSuccess" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      receiveAddress:{}, //收货地址信息
      addressInfoWidth: (parseInt(document.documentElement.clientWidth)-100) ,
      cartItemProductInfoWidth: (parseInt(document.documentElement.clientWidth)-130),
      productInfoList:[],
      totalPrice : 0,
      totalPayPrice : 0,
      orderInfo:{
        remark:'',
        skuId:0
      },
      orderNos:[], 
      multiLineInputErrorText:''
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()
    this.getDefaultAddress()
    this.getProductList()
  },
  methods: {
    //查询默认收货地址
    getDefaultAddress(){
      var ths = this
      ths.$post(
        "/Shop/UserServer/GetDefaultReceiveAddress"
      ).then(function(res) {
        if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)   
        }else{   
          ths.receiveAddress = res.Data
          //ths.orderSubmitDto.addrId = res.Data.Id
        }
		//ths.getCandyInfo()		
      });
      
    },
    handleMultiLineOverflow (isOverflow) {
      this.multiLineInputErrorText = isOverflow ? '不能超过50个字符' : ''
    },
    getProductList(){
      var skuid = this.$route.query.skuId? parseInt(this.$route.query.skuId):0
      var ths = this
      ths.$post(
        "/Salesman/SalesmanServer/GetSalesmanProductBySkuId", {SkuId: skuid}
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.productInfoList.push(res.Data)
          var count = 1
          ths.totalPrice += res.Data.SalePrice * count
          ths.totalPayPrice = ths.totalPrice; 
          ths.orderInfo.skuId = res.Data.SkuId
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },    
    orderSubmit(){
      var ths = this
      if (!this.receiveAddress.Id){
        this.$refs.XRtoast.failed("请选择收货地址", true)
			  return;
      }
      this.orderInfo.AddrId = this.receiveAddress.Id;

      ths.$post(
        "/Salesman/SalesmanServer/UpgradeSalesmanOrderSubmit",
        JSON.stringify(this.orderInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.orderNos = res.Data
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    submitSuccess(){
      this.$router.push('/salesman/orderPay?orderNo='+this.orderNos)
    }
  },
  watch :{
    productList: function(){
      var price = 0;
      for(var i = 0; i< this.productList.length;i++){
        for(var j = 0; j< this.orderInfo.productList.length;j++){
          if(this.productList[i].SkuId == this.orderInfo.productList[j].skuId ){            
            price += this.productList[i].SalePrice * this.orderInfo.productList[j].count
          }
        }
      }
      this.totalPrice = price
    }
  }
}
</script>
<style>
body .SalesmanOrderSubmit{
  background: #F0F2F5;
  bottom: unset;
}
.pageContent{
  padding-bottom: 56px;
}

.SalesmanOrderSubmit .goIcon{
  width: 20px;
  float: right;
  text-align: right;
}

.SalesmanOrderSubmit .mapIcon{
  float: left;
  width: 30px;
  line-height: 40px;
}
.SalesmanOrderSubmit .mapIcon img{
  width:100%;
  display: block;
  margin-top: 13px;
}

.SalesmanOrderSubmit .receive-address{
  background: white;
  color:black;
  padding: 20px 20px;
  overflow: hidden;
  margin-top: 12px;
  border-radius: 10px;
}
.SalesmanOrderSubmit .receive-address .address-info{
  float: left;
  margin-left: 10px;
}
.SalesmanOrderSubmit .receive-address .address-info .name{
  font-size:16px;
  padding-right: 10px;
}
.SalesmanOrderSubmit .receive-address .address-info .mobile{
  font-size:14px;
  color:#aaa;
}
.SalesmanOrderSubmit .receive-address .address-info .address-content{
  font-size:12px;
  color:#666;
  line-height: 14px;
  height: 28px;
  margin-top: 5px;
}
.SalesmanOrderSubmit .receive-address .address-info .address-content .fa{
  width: 20px;
}
.SalesmanOrderSubmit .receive-address .goIcon{
  width:20px;
  height: 14px;
  margin-top: 20px;
}

.SalesmanOrderSubmit .choose-info{
  overflow: hidden;
  padding:10px;
  background: white;
  margin-top: 10px;
}
.SalesmanOrderSubmit .choose-info .info{
  font-size: 12px;
  float: left;
  line-height: 24px;
}
.SalesmanOrderSubmit .choose-info .info.center{
  float: right;
}
.SalesmanOrderSubmit .choose-info .info.left {
  width: 150px;
}
.SalesmanOrderSubmit .choose-info .info.left .title{
  font-size: 14px;
  font-weight: 700;
}
.SalesmanOrderSubmit .choose-info .info .choose-row{
  line-height: 24px;
}
.SalesmanOrderSubmit .choose-info .info.center .choose-row{
  text-align: right;
}
.SalesmanOrderSubmit .choose-info.integral .info.left .choose-row.balance{
  color:red;
}
.SalesmanOrderSubmit .choose-info .goIcon{
  line-height: 48px;
}

.SalesmanOrderSubmit .remark{
  background: white;
  margin-top: 10px;
  padding:10px 10px 0;
}

.SalesmanOrderSubmit .price-info{
  background: white;
  margin-top: 10px;
  padding:10px 10px 40px;
}
.SalesmanOrderSubmit .price-info .row{
  background: white;
  overflow: hidden;
  line-height: 32px;
}
.SalesmanOrderSubmit .price-info .row .title{
  font-size: 14px;
  font-weight: 700;
}
.SalesmanOrderSubmit .price-info .row .price{
  color:Red;
  font-weight: 700;
}



.SalesmanOrderSubmit .pro-list{
  margin-top: 10px;
  background: white;
  overflow: hidden;
}
.SalesmanOrderSubmit .pro-list .pro-item{
  padding: 16px 0;
  overflow: hidden;
}
.SalesmanOrderSubmit .pro-list .pro-item .pro-img{
  width: 80px;
  float: left;
}
.SalesmanOrderSubmit .pro-list .pro-item .pro-img img{
  width: 100%;
  height: 80px;
  display: block;
  border-radius: 4px;
  margin: 0 20px;
}
.SalesmanOrderSubmit .pro-list .pro-item .pro-info{
  float: right;
  padding-right: 10px;
}
.SalesmanOrderSubmit .pro-list .pro-item .pro-info .pro-name{
  font-size: 12px;
  line-height: 16px;
  height: 32px;
  padding-bottom: 4px;
  overflow: hidden;
}
.SalesmanOrderSubmit .pro-list .pro-item .pro-info .pro-attr{
  font-size: 12px;
  line-height: 16px;
  height: 30px;
  color:#999;
}
.SalesmanOrderSubmit .pro-list .pro-item .pro-info .pro-num{
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  color:#999;
}
.SalesmanOrderSubmit .pro-list .pro-item .pro-info .pro-num .pro-price{
  font-size: 16px;
  line-height: 16px;
  float: left;
  color:red;
}
.SalesmanOrderSubmit .pro-list .pro-item .pro-info .pro-num .count{
  font-size: 12px;
  line-height: 16px;
  color:#999;
  float: right;
}




.SalesmanOrderSubmit .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  height: 56px;
  border-top:1px solid #eee;
}
.SalesmanOrderSubmit .bottom-bar .cart-total{
  float: left;
  height: 56px;
  line-height: 56px;
  padding-left: 20px;
  font-size: 16px;
  font-weight: 700;
  color:Red;
}
.SalesmanOrderSubmit .gobuy{
  width: 100%;
  line-height: 56px;
  height: 56px;
  text-align: center;
}

.SalesmanOrderSubmit-popupLayer {
  width: 100%;
  min-height: 120px;
}
.SalesmanOrderSubmit-popupLayer .deliveryChoose {
  padding: 0 10px;
}
.SalesmanOrderSubmit-popupLayer .delvieryChooseBtn{
  margin: 40px 0 0;
  height: 50px; 
}

.SalesmanOrderSubmit-popupLayer .shippingBtn.select{
  background: red;
  color:white;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesman/orderSubmit.vue